import { AdminContext } from 'constants/contexts';
import useFetchedData from 'hooks/useFetchedData';
import { useContext, useMemo } from 'react';

function useCateringRestaurants() {
  const { organizationId } = useContext(AdminContext);

  const { data, loading, error } = useFetchedData(
    organizationId ? {
      url: `v1/organizations/${organizationId}/merchants/`,
      query: {
        is_catering: true,
        is_disabled: false,
        page_size: 300,
      },
    } : null,
    (response = {}) => (response?.data?.results || response?.results || []),
  );

  const restaurants = useMemo(
    () => (data || []).filter((restaurant) => !restaurant.is_disabled),
    [data],
  );

  const restaurantOptions = restaurants.map((restaurant) => ({
    value: restaurant.id,
    label: restaurant.name,
  }));

  return {
    restaurants,
    restaurantOptions,
    loading,
    error,
  };
}

export default useCateringRestaurants;
